import { z } from 'zod';
import { telRegex } from '../../../utils/tel-regex';

export const personalDataSchema = z.object({
  firstName: z
    .string()
    .max(45, {
      message: 'Der Name darf höchstens 45 Zeichen lang sein'
    })
    .min(1, {
      message: 'Vorname ist erforderlich'
    }),
  lastName: z.string().min(1, {
    message: 'Nachname ist erforderlich'
  }),
  phone: z
    .string()
    .trim()
    .transform((val) => val.replace(/\s/g, ''))
    .refine((val) => telRegex.test(val), {
      message: 'Ungültige Telefonnummer. Geben Sie es in folgendem Format ein: +49123123123'
    }),
  name: z.string().min(1, {
    message: 'Unternehmensname ist erforderlich'
  }),
  country: z.string().min(1, {
    message: 'Land ist erforderlich'
  }),
  vatId: z.string().min(1, {
    message: 'Umsatzsteuer-ID ist erforderlich'
  }),
  street: z.string().min(1, {
    message: 'Straße ist erforderlich'
  }),
  houseNumber: z.string().min(1, {
    message: 'Hausnummer ist erforderlich'
  }),
  postCode: z.string().min(1, {
    message: 'PLZ ist erforderlich'
  }),
  city: z.string().min(1, {
    message: 'Stadt ist erforderlich'
  })
});

export type PersonalDataSchemaType = z.infer<typeof personalDataSchema>;
